import { createFeature, createReducer, on } from '@ngrx/store';
import * as UploadActions from './upload.actions';
import { Upload, initialState } from './upload.state';

export const uploadFeature = createFeature({
  name: 'upload',
  reducer: createReducer(
    initialState,

    on(UploadActions.startUpload, (state, { file }) => {
      if (state.uploads[file.id]) {
        return state; // Avoid duplicates
      }
      const newUpload: Upload = {
        id: file.id,
        file,
        status: 'pending',
        progress: 0,
        error: null,
      };
      return {
        ...state,
        uploads: {
          ...state.uploads,
          [file.id]: newUpload,
        },
      };
    }),

    on(UploadActions.uploadProgress, (state, { id, progress }) => {
      const upload = state.uploads[id];
      if (!upload) return state;
      const updatedUpload: Upload = { ...upload, progress, status: 'in-progress' };
      return { ...state, uploads: { ...state.uploads, [id]: updatedUpload } };
    }),

    on(UploadActions.uploadSuccess, (state, { id }) => {
      const upload = state.uploads[id];
      if (!upload) return state;
      const updatedUpload: Upload = { ...upload, progress: 100, status: 'success' };
      return { ...state, uploads: { ...state.uploads, [id]: updatedUpload } };
    }),

    on(UploadActions.uploadFailure, (state, { id, error }) => {
      const upload = state.uploads[id];
      if (!upload) return state;
      const updatedUpload: Upload = { ...upload, status: 'error', error };
      return { ...state, uploads: { ...state.uploads, [id]: updatedUpload } };
    }),

    on(UploadActions.cancelUpload, (state, { id }) => {
      const { [id]: _, ...uploads } = state.uploads;
      return { ...state, uploads };
    }),

    on(UploadActions.clearUploads, () => initialState)
  ),
});

export const {
  name: uploadFeatureKey,
  reducer: uploadReducer,
  selectUploadState,
  selectUploads,
} = uploadFeature;
